import { useTuxedo } from '@/reports/index';
import { Button, Text } from '@/theme/components';
import { styled } from '@/theme/index';
import { InitialRecordSearch } from '../../PerksPage';
import { Reward } from '../../rewards/types';

const StyledButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    maxWidth: '200px',
  },
}));

export const Recommendation: React.FC<{
  reward: Reward;
  initialRecordSearch: InitialRecordSearch;
}> = ({ reward, initialRecordSearch }) => {
  const { recommendations } = useTuxedo();

  const { data } = recommendations(initialRecordSearch, reward.name);

  const handleClick = () => {
    const cta_url = data.recommendation?.partner_response?.home?.[0]?.cta_url;
    window.open(cta_url, '_blank');
  };

  const quote =
    data.recommendation?.partner_response?.home?.[0]?.monthly_quote_amt;

  return (
    <>
      <Text variant="h2" mb={2} mt={1}>
        Insurance Quote Details
      </Text>
      <Text variant="body1" mb={[2, 4]}>
        Get $5 when you request a customized homeowner insurance quote from
        Bubble*
      </Text>
      <Text variant="h4">Home Insurance Monthly Rate: ${quote}</Text>
      <StyledButton
        fullWidth
        variant="contained"
        color="success"
        onClick={() => handleClick()}
      >
        Customize your Quote
      </StyledButton>
    </>
  );
};
